import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/invoice`。
 * DELIVERED → INVOICED；INVOICED 可再打修正。
 * body：`invoiceNo`、`invoicedAt`、`invoiceTitle`、`taxIdNumber`、`updatedAt`。
 */
export async function invoiceSalesOrder(id, payload) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/invoice`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
